'use client';

import ModalBox from '@/components/modalBox/ModalBox';
import { type ReactNode, useState } from 'react';

import InfoIcon from './InfoIcon';

export interface InfoIconModal {
  children?: ReactNode;
  headline?: string;
  theme?: 'whiteMagenta' | 'green' | 'blue' | 'whiteGreen' | 'orange';
  size?: number;
  modalClassName?: string;
  className?: string;
  trackingLabel?: string;
}

const InfoIconModal: React.FC<InfoIconModal> = (props) => {
  const [open, setOpen] = useState(false);
  const toggleOpen = () => setOpen((prevState) => !prevState);

  return (
    <ModalBox
      heading={props.headline}
      button={
        <InfoIcon
          onClick={toggleOpen}
          className={props.className}
          size={props.size}
          theme={props.theme}
          trackingLabel={props.trackingLabel}
        />
      }
      large={false}
      open={open}
      toggleOpen={toggleOpen}
      className={props.modalClassName}
    >
      {props.children}
    </ModalBox>
  );
};
export default InfoIconModal;
